import router from "@/router";
import { useStore } from "vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { ElMessage } from "element-plus";
import "element-plus/es/components/message/style/css";

router.beforeEach(async (to, from, next) => {
  NProgress.start(); // 开始进度条
  const store = useStore();
  if (to.path === "/tel/verify") {
    next();
  } else if (to.path === "/tel/bindData") {
    const verify = store.getters.isVerify; // 是否已经验证
    if (verify) {
      next();
    } else {
      ElMessage.error("请先实名认证");
      next("/tel/verify");
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});
